var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('RouterLink',{attrs:{"to":{ name: _vm.name, params: _vm.params }}},[_vm._v(_vm._s(_vm.label))]):_c('span',[_vm._v("–")])}
var staticRenderFns = []

export { render, staticRenderFns }